import { useNavigate } from 'react-router-dom';

const artists = [
  {
    name: 'Kaspar',
    genre: 'Techno / Dark Techno',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/c2d15c9d-fd4c-48dc-b884-daf68069091b_Kaspar.jpg?v=ae681d534a82fcab2131843f9ec7ab47',
    achievement: '#1 Beatport Techno 100',
    label: 'Fe Chrome Records',
    externalUrl: 'https://www.instagram.com/kaspar_de/',
  },
  {
    name: 'Le Shuuk',
    genre: 'Big Room / Hard Dance',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/27ca7182-572f-49e2-ae6f-fb520e5f0e49_Le-Shuuk.jpg?v=8b16b3a6cf7afe40ba47d1f36d5ab535',
    achievement: 'International DJ',
    label: 'AceAge Records',
    externalUrl: 'https://www.instagram.com/leshuuk/',
  },
  {
    name: 'Captain Jack',
    genre: 'Eurodance / Pop',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/53e2a153-3ed8-4eb1-bc33-987b5e24c41a_cAPTAIN-jaCK.png?v=8f0ead2315e33d9b1f5191f2f2b373a0',
    achievement: '90s Dance Legend',
    label: 'AceAge Records',
    externalUrl: 'https://www.facebook.com/CaptainJackOfficial/',
  },
  {
    name: 'Talla 2XLC',
    genre: 'Trance / Electronic',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/ea6fb336-104d-41d0-82e6-649148be6398_Talla-2xlc.jpg?v=c20b1ad0f45e3d7938c36639541ac713',
    achievement: 'Trance Pioneer',
    label: 'AceAge Records',
    externalUrl: 'https://www.facebook.com/talla2xlcfansite/',
  },
  {
    name: 'Lyah Noir',
    genre: 'Hard Techno',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/9e08a02d-9c6c-4364-8014-0604cdf94aa6_lyahnoir-2695853793.jpg?v=af1ee3c98a014ed825c2682939b67b0b',
    achievement: 'Hard Techno Queen',
    label: 'Fe Chrome Records',
    externalUrl: 'https://www.youtube.com/@lyahnoir',
  },
  {
    name: 'NULLHERTZ',
    genre: 'Peaktime Techno',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/768f0dde-3bca-4bcf-b76e-527060f42175_ChatGPT-Image-24.-Apr.-2026-01_07_49.png?v=2ebad0ca5d8ecfc4d95d2f62da7dfdf8',
    achievement: 'Techno Powerhouse',
    label: 'Fe Chrome Records',
    externalUrl: 'https://www.beatport.com/de/artist/nullhertz/1414176',
  },
  {
    name: 'DJ Meela',
    genre: 'Tech House / Bass House',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/a86b013c-df76-4169-b4e5-eede9b679f52_WhatsApp-Image-2026-04-22-at-15.14.44.jpeg?v=2c166e21047db107fabb5d7e243d9356',
    achievement: 'Tech House Artist',
    label: 'AceAge Records',
    externalUrl: 'https://meeladj.de/',
  },
  {
    name: 'MOREES',
    genre: 'Melodic Techno',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/46240058-3747-4287-bb31-c8560ad8c4c5_WhatsApp-Image-2026-04-22-at-14.49.28.jpeg?v=1bc80f96a79c6020414720ea44b643f7',
    achievement: 'Melodic Techno Artist',
    label: 'AceAge Records',
    externalUrl: 'https://www.instagram.com/moestwanted/',
  },
];

export default function FeaturedCampaigns() {
  const navigate = useNavigate();
  return (
    <section id="artists" className="relative py-32 px-6 overflow-hidden" data-product-shop>
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=massive%20live%20stadium%20concert%20at%20night%20with%20thousands%20of%20fans%20holding%20glowing%20phone%20lights%20creating%20a%20sea%20of%20warm%20golden%20and%20amber%20stars%2C%20dramatic%20stage%20lighting%20with%20powerful%20spot%20beams%20cutting%20through%20the%20arena%2C%20deep%20dark%20atmosphere%20with%20rich%20warm%20yellow%20and%20orange%20highlights%20from%20the%20crowd%20and%20stage%2C%20epic%20live%20music%20event%20ambience%2C%20wide%20panoramic%20shot%2C%20cinematic%20professional%20photography%2C%20no%20people%20in%20sharp%20focus%2C%20abstract%20dark%20texture%20with%20warm%20glowing%20lights&width=1920&height=1080&seq=roster-bg-stadium-live-2&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#0a0a0a]/70" />
        <div className="absolute inset-x-0 top-0 h-48 bg-gradient-to-b from-black to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-black to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <span className="w-10 h-px bg-white/30" />
          <span className="text-white/40 text-xs font-medium tracking-[0.3em] uppercase">Our Clients</span>
        </div>
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
          <h2 className="text-white font-bold leading-tight" style={{fontSize: 'clamp(2.5rem, 5vw, 4rem)', fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.02em'}}>
            The Roster
          </h2>
          <p className="text-white/50 text-sm max-w-sm leading-relaxed lg:text-right">
            A curated roster of talented artists across a wide range of genres and styles, united by a shared passion for exceptional music craftsmanship.
          </p>
        </div>

        {/* Artist Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {artists.map((artist, i) => {
            const cardContent = (
              <>
                <div className="w-full aspect-square overflow-hidden">
                  <img
                    src={artist.image}
                    alt={artist.name}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                {artist.externalUrl && (
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" />
                )}
                {/* Info */}
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="text-white font-bold text-xl mb-0.5" style={{fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.05em'}}>{artist.name}</h3>
                  <p className="text-white/60 text-xs">{artist.genre}</p>
                  <div className="mt-3 flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="w-4 h-px bg-white/60" />
                    <span className="text-white/80 text-xs font-medium">{artist.achievement}</span>
                  </div>
                </div>
                {/* Number badge */}
                <div className="absolute top-4 right-4 w-7 h-7 flex items-center justify-center bg-black/60 rounded-full">
                  <span className="text-white/50 text-xs font-bold">{String(i + 1).padStart(2, '0')}</span>
                </div>
              </>
            );

            if (artist.externalUrl) {
              return (
                <a
                  key={i}
                  href={artist.externalUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative overflow-hidden rounded-lg group cursor-pointer block"
                >
                  {cardContent}
                </a>
              );
            }

            return (
              <div
                key={i}
                className="relative overflow-hidden rounded-lg group"
              >
                {cardContent}
              </div>
            );
          })}
        </div>

        {/* Catalog CTA */}
        <div className="mt-12 flex justify-center">
          <button
            onClick={() => navigate('/catalog')}
            className="flex items-center gap-3 border border-white/20 hover:border-white/50 text-white/70 hover:text-white text-xs font-medium tracking-[0.25em] uppercase px-7 py-3 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-album-line w-4 h-4 flex items-center justify-center" />
            View Full Catalog
          </button>
        </div>
      </div>
    </section>
  );
}
